export default __webpack_public_path__ + "static/media/sideNavIcon.ef77e226.svg";